<template>
    <div class="ion-page">
        <ion-header>
        <ion-toolbar>
            <ion-buttons v-slot: start>
            <ion-menu-button></ion-menu-button>
            </ion-buttons>
            <ion-title>Charging Stations List</ion-title>
            <ion-buttons slot="end">
            <ion-button @click="addStation" v-if="rightToAdd" class="hdrBtn">
                <ion-icon v-slot: start :icon="add"></ion-icon>&nbsp;Add New Charging Station
                <!-- <ion-icon slot="icon-only" name="add"></ion-icon>  class="btn-add" -->
            </ion-button>
            </ion-buttons>
        </ion-toolbar>
        </ion-header>
        <ion-content class="ion-padding">
        <ChargingStations />
        </ion-content>
    </div>
</template>
<script>
import { defineComponent } from "vue";
import ChargingStations from "@/components/admin/ChargingStations.vue";
import { AppUtils } from "@/util/app-utils"
import { IonButton, IonButtons, IonContent, IonHeader, IonIcon, IonMenuButton, IonTitle, IonToolbar } from '@ionic/vue';
import { add } from 'ionicons/icons';

export default defineComponent({
    name:  'chargingStations',
    components: {
        ChargingStations, IonHeader, IonToolbar, IonButtons, IonMenuButton,IonTitle, IonButton, IonIcon, IonContent
    },
    data() {
        return {
            add,
            rightToAdd: false
        }
    },
    mounted() {
        this.rightToAdd = new AppUtils().getUserAccess("40|C");
    },
    methods: {
        addStation() {
        this.$router.push("/admin/chargingstations/station");
        }
    }
})
</script>
